import { IPublishedAnnouncement, IResidentAnnouncementContent } from '../../../models';

export const announcementConverter = {
  fromDto: (response: IResidentAnnouncementContent): IPublishedAnnouncement => {
    return {
      id: response.id,
      title: response.title,
      text: response.text,
      publishedAt: response.publishedAt,
      attachments: response.attachments,
    };
  },
};
